// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ee93c6e3","239":"4cde6012","455":"4982173f"}[chunkId] + ".chunk.js";
};